module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), (_vm.update == true) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)] : _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Create a new application")])])], 2)]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showClientCredentialsModal
    },
    on: {
      "close": _vm.hideClientCredentialsModal
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Notice")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-warning"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Please, copy the "), _c('strong', [_vm._v("identifier")]), _vm._v(" below and store it in a safe place. This will not be shown again.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Identifier:")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.$store.state.client.identifier))])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.hideClientCredentialsModal
    }
  }, [_vm._v("OK")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Application name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name),
      expression: "fields.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Client name",
      "data-vv-as": "Client name"
    },
    domProps: {
      "value": (_vm.fields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('name')),
      expression: "veeErrors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Platform")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    class: {
      'select': true, 'is-danger': _vm.veeErrors.has('platform')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.platform),
      expression: "fields.platform"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "platform",
      "disabled": _vm.update,
      "data-vv-as": "Platform"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fields, "platform", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select one option")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "android"
    }
  }, [_vm._v("Android")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ios"
    }
  }, [_vm._v("iOS")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('platform')),
      expression: "veeErrors.has('platform')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('platform')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Package name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.package_name),
      expression: "fields.package_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^[A-Za-z0-9-_.]+$'),
      expression: "'required|regex:^[A-Za-z0-9-_.]+$'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('package_name')
    },
    attrs: {
      "name": "package_name",
      "type": "text",
      "placeholder": "Package name",
      "disabled": _vm.update,
      "data-vv-as": "Package name"
    },
    domProps: {
      "value": (_vm.fields.package_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "package_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('package_name')),
      expression: "veeErrors.has('package_name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('package_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Permissions")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, _vm._l((this.$store.state.permissions), function(permission) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedPermissions),
        expression: "checkedPermissions"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("field_" + (permission.name))
      },
      domProps: {
        "value": permission.id,
        "checked": Array.isArray(_vm.checkedPermissions) ? _vm._i(_vm.checkedPermissions, permission.id) > -1 : (_vm.checkedPermissions)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedPermissions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = permission.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedPermissions = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedPermissions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedPermissions = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("field_" + (permission.name))
      }
    }, [_vm._v(_vm._s(permission.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": _vm.cancelUrl,
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit application name")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b608d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients/ClientForm.vue
// module id = 343
// module chunks = 1